import { ProfileV1 } from './profile-v1';
import { ProfileLine } from './profile-line';
import { EProfilePaintSide } from './e-profile-paint-side';

export class Profile extends ProfileV1 {
    public lines: ProfileLine[] = [];

    constructor(profileData?: string) {
        super();
        this.load(profileData);
    }

    public load(profileData: string): void {
        if (profileData && !profileData.startsWith('v2')) {
            super.load(profileData);
            return;
        }

        this.clear(false);

        if (!profileData) {
            this.propagateChanges();
            return;
        }

        const data = profileData.split('%');
        this.paintSide = parseInt(data[1], 10) || EProfilePaintSide.noPaint;
        this.creaseLeft = Profile.parseEdgeCrease(data[2]) || this.creaseLeft;
        this.edgeCreaseSizeMM = parseInt(data[3], 10) || this.edgeCreaseSizeMM;
        this.creaseRight = Profile.parseEdgeCrease(data[4]) || this.creaseRight;

        const parsedLines = data[6]?.split('|') ?? [];
        const reg = /^([01]?);(\d+);(\d);(\d+);(\d+);([^;]*);([^;]*);([^;]*);([^;]*);([^;]*);([^;]*)$/;

        parsedLines.forEach(lineData => {
            const parts = reg.exec(lineData);
            if (parts) {
                const angle = parseInt(parts[2], 10);
                const direction = 2 * parseInt(parts[3], 10) - 1;

                this.lines.push({
                    restrictTrapeze: Boolean(Number(parts[1])),
                    length: parseInt(parts[4], 10),
                    length2: parseInt(parts[5], 10),
                    alpha: angle * direction,
                    direction: direction,
                    lengthMin: parseInt(parts[6], 10) || undefined,
                    lengthMax: parseInt(parts[7], 10) || undefined,
                    length2Min: parseInt(parts[8], 10) || undefined,
                    length2Max: parseInt(parts[9], 10) || undefined,
                    angleMin: parseInt(parts[10], 10) || undefined,
                    angleMax: parseInt(parts[11], 10) || undefined,
                });
            }
        });

        this.propagateChanges();
    }

    public toString(): string {
        if (!this.lines.length) {
            return null;
        }
        const lines = this.lines.map((line, index) => {
            let alpha = line.alpha;
            let direction = line.direction;
            if (!index) {
                const startLineAngle = Profile.recalculateStartLineAngle(line.alpha, line.direction, 0);
                alpha = startLineAngle.angle;
                direction = startLineAngle.direction;
            }
            return [
                line.restrictTrapeze ? 1 : 0,
                Math.abs(alpha),
                (direction + 1) / 2,
                line.length,
                line.length2,
                line.lengthMin,
                line.lengthMax,
                line.length2Min,
                line.length2Max,
                line.angleMin,
                line.angleMax,
            ].join(';');
        });
        return [
            'v2', this.paintSide,
            this.creaseLeft, this.edgeCreaseSizeMM,
            this.creaseRight, this.edgeCreaseSizeMM,
            lines.join('|'),
            this.lengthTotal(),
        ].join('%');
    }
}
